/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowsInSimple(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M213.65723,53.65723,187.31445,80l18.34278,18.34277A8.00066,8.00066,0,0,1,200,112H152a8.00039,8.00039,0,0,1-8-8V56a8.00066,8.00066,0,0,1,13.65723-5.65723L176,68.68555l26.34277-26.34278a8.00053,8.00053,0,0,1,11.31446,11.31446ZM104,144H56a8.00066,8.00066,0,0,0-5.65723,13.65723L68.68555,176,42.34277,202.34277a8.00053,8.00053,0,0,0,11.31446,11.31446L80,187.31445l18.34277,18.34278A8.00066,8.00066,0,0,0,112,200V152A8.00039,8.00039,0,0,0,104,144Z" />
    </Svg>
  );
}

export default ArrowsInSimple;
